import { useState, useEffect } from 'react';
import { AlertTriangle } from 'lucide-react';

const AgeVerification = () => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    // Check if user has already verified their age
    const ageVerified = localStorage.getItem('ageVerified');
    if (!ageVerified) {
      setShowModal(true);
    }
  }, []);

  const handleConfirm = () => {
    localStorage.setItem('ageVerified', 'true');
    setShowModal(false);
  };

  const handleDecline = () => {
    // Redirect to responsible gaming page or show message
    window.location.href = '/responsible-gaming';
  };

  if (!showModal) return null;

  return (
    <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4">
      <div className="bg-dark-black border-2 border-toxic-orange rounded-xl p-8 max-w-md w-full">
        <div className="flex items-center gap-3 mb-6">
          <AlertTriangle className="text-toxic-orange" size={32} />
          <h2 className="text-2xl font-bold text-white">Age Verification Required</h2>
        </div>
        
        <p className="text-gray-300 mb-6 leading-relaxed">
          You must be 18 years or older to access this website. Online gambling is restricted to individuals who have reached the legal age of majority in their jurisdiction.
        </p>
        
        <p className="text-gray-300 mb-8 leading-relaxed">
          By clicking "I am 18 or older", you confirm that you are of legal age to gamble in your jurisdiction and agree to our Terms & Conditions.
        </p>

        <div className="flex flex-col sm:flex-row gap-4">
          <button
            onClick={handleDecline}
            className="flex-1 border-2 border-gray-600 text-gray-300 px-6 py-3 rounded-lg font-semibold hover:border-gray-500 hover:text-white transition-colors"
          >
            I am under 18
          </button>
          <button
            onClick={handleConfirm}
            className="flex-1 bg-toxic-orange text-dark-black px-6 py-3 rounded-lg font-semibold hover:bg-orange-500 transition-colors"
          >
            I am 18 or older
          </button>
        </div>

        <p className="text-gray-500 text-xs mt-6 text-center">
          For support with problem gambling, visit <a href="https://www.begambleaware.org" target="_blank" rel="noopener noreferrer" className="text-toxic-orange hover:text-orange-400">BeGambleAware.org</a>
        </p>
      </div>
    </div>
  );
};

export default AgeVerification;

